var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svgicon',{class:( _obj = {}, _obj[_vm.$options.name] = true, _obj['default-size'] =  _vm.defaultSize, _obj ),attrs:{"name":_vm.name,"fill":_vm.fill,"original":_vm.original}})}
var staticRenderFns = []

export { render, staticRenderFns }